import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import { PURGE_AUTH } from "@/core/services/store/auth.module";
import store from "@/core/services/store";
import Swal from "sweetalert2";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
    Vue.axios.defaults.headers.common["Accept-Language"] = "fa-IR";
  },

  /**
   * @param resource
   * @param params
   * @param catchError
   * @returns {Promise<AxiosResponse<any>>}
   */
  query(resource, params, catchError = true) {
    return Vue.axios.get(resource, params).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw new Error(`ApiService ${error}`);
      }
    });
  },

  /**
   * @param resource
   * @param slug
   * @param catchError
   * @returns {Promise<AxiosResponse<any>>}
   */
  get(resource, slug = "", catchError = true) {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw new Error(`ApiService ${error}`);
      }
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @param config
   * @param catchError
   * @returns {*}
   */
  post(resource, params, config = null, catchError = true) {
    return Vue.axios.post(`${resource}`, params, config).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw error;
      }
    });
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @param catchError
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params, catchError = true) {
    return Vue.axios.put(`${resource}/${slug}`, params).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw error;
      }
    });
  },

  /**
   * Send the PATCH HTTP request
   * @param resource
   * @param params
   * @param catchError
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  patch(resource, params, catchError = true) {
    return Vue.axios.patch(`${resource}`, params).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw error;
      }
    });
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @param catchError
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params, catchError = true) {
    return Vue.axios.put(`${resource}`, params).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw error;
      }
    });
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @param params
   * @param catchError
   * @returns {*}
   */
  delete(resource, params = null, catchError = true) {
    return Vue.axios.delete(resource, params).catch(error => {
      this.handleError(error, catchError);
      if (error.response) {
        throw new Error(`ApiService ${error}`);
      }
    });
  },

  handleError(error, catchError) {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          if (catchError) {
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: "error",
              showCloseButton: false,
              confirmButtonText: "بستن",
              confirmButtonColor: "#4554a0",
              heightAuto: false
            });
          }
          break;
        case 401:
          store.commit(PURGE_AUTH);
          break;
        case 403:
          if (catchError) {
            Swal.fire({
              title: "",
              text: error.response.data.message
                ? error.response.data.message
                : "دسترسی به منبع مورد نظر وجود ندارد",
              icon: "error",
              showCloseButton: false,
              confirmButtonText: "بستن",
              confirmButtonColor: "#4554a0",
              heightAuto: false
            });
          }
          break;
        case 404:
          if (catchError) {
            Swal.fire({
              title: "",
              text: "منبع مورد نظر وجود ندارد",
              icon: "error",
              showCloseButton: false,
              confirmButtonText: "بستن",
              confirmButtonColor: "#4554a0",
              heightAuto: false
            });
          }
          break;
        case 422:
          if (catchError) {
            Swal.fire({
              title: "",
              text: error.response.data.error,
              icon: "error",
              showCloseButton: false,
              confirmButtonText: "بستن",
              confirmButtonColor: "#4554a0",
              heightAuto: false
            });
          }
          break;
        case 429:
          Swal.fire({
            title: "",
            text:
              "درخواست بیش از اندازه، لطفا کمی صبر و سپس دوباره تلاش نمایید",
            icon: "error",
            showCloseButton: false,
            confirmButtonText: "بستن",
            confirmButtonColor: "#4554a0",
            heightAuto: false
          });
          break;
        default:
          // if (catchError) {
          //   Swal.fire({
          //     title: "",
          //     text: error.response.data.error
          //       ? error.response.data.error
          //       : "خطای سرور",
          //     icon: "error",
          //     showCloseButton: false,
          //     confirmButtonText: "بستن",
          //     confirmButtonColor: "#4554a0",
          //     heightAuto: false
          //   });
          // }
      }
    }
    // else {
    //   Swal.fire({
    //     title: "خطای شبکه",
    //     text: "لطفا اتصال اینترنت خود را بررسی کنید.",
    //     icon: "error",
    //     showCloseButton: false,
    //     showConfirmButton: false,
    //     showCancelButton: false
    //   });
    // }
  }
};

export default ApiService;
